var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("工单信息")]),
              _c(
                "el-button",
                {
                  staticClass: "float-right",
                  attrs: { type: "text" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("返回")]
              )
            ],
            1
          ),
          _c(
            "el-form",
            { attrs: { model: _vm.form, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工单ID" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.TicketId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "TicketId", $$v)
                      },
                      expression: "form.TicketId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.ticketData.length
            ? _c(
                "el-table",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { data: _vm.ticketData, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "AssetId", label: "资产ID", width: "150" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "IdcpName", label: "源机房" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "OppositeIdcpName", label: "目的机房" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "LogisticsNum",
                      label: "物流单号",
                      width: "180"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Model", label: "型号" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ServerHeight",
                      label: "高度(U)",
                      width: "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "TaskStatus",
                      label: "任务状态",
                      width: "100"
                    }
                  })
                ],
                1
              )
            : _c("el-empty", { attrs: { description: "暂无数据" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }